export default {
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',
  LOGOUT_COMPLETE: 'LOGOUT_COMPLETE',
  TOKEN_VERIFIED: 'TOKEN_VERIFIED',
  REFRESH_PROFILE: 'REFRESH_PROFILE',
  UPDATE_TOKEN: 'UPDATE_TOKEN',
  SET_CUSTOM_LOGIN: 'SET_CUSTOM_LOGIN',
  CLEAR_CUSTOM_LOGIN: 'CLEAR_CUSTOM_LOGIN',
}
